enum ContentType {
  Read,
  Watch,
  Listen,
  Video360,
}

export default ContentType;
